<script lang="ts" setup>
import { UserNotification } from '@/enitites/user'
import { useRouter } from 'vue-router/composables'
import NotificationEventFeedbackAttendee from './NotificationEventFeedbackAttendee.vue'
import NotificationEventFeedbackOrganizer from './NotificationEventFeedbackOrganizer.vue'

const props = defineProps<{
  notification: UserNotification
  readUserNotification: (notification: UserNotification) => void
}>()

const router = useRouter()

const handleClickLink = () => {
  if (router.currentRoute.path !== props.notification.link) {
    router.push(props.notification.link)
  }
  props.readUserNotification(props.notification)
}
</script>

<template>
  <div class="notification-card">
    <div class="notification-header">
      <div class="notification-title">
        {{ notification.title }}
      </div>
      <button
        class="close-button"
        @click.stop="readUserNotification(notification)"
      >
        <img
          alt="close"
          class="icon"
          src="/img/ic_Close_Red.svg"
        />
      </button>
    </div>
    <div class="notification-info">
      <div class="notification-text">
        {{ notification.text }}
      </div>
    </div>
    <div class="notification-actions-container">
      <button
        v-if="notification.notificationType === 'battle_invite' || notification.notificationType === 'event_invite'"
        class="notification-action"
        @click="handleClickLink"
      >
        <span v-if="notification.notificationType === 'battle_invite'">Open battle</span>
        <span v-if="notification.notificationType === 'event_invite'">Open event</span>
      </button>
      <NotificationEventFeedbackOrganizer
        v-if="notification.notificationType === 'event_feedback_organizer'"
        class="notification-actions-container"
        :notification="notification"
        :read-user-notification="readUserNotification"
      />
      <NotificationEventFeedbackAttendee
        v-if="notification.notificationType === 'event_feedback_attendee' && notification.eventId"
        class="notification-actions-container"
        :notification="notification"
        :read-user-notification="readUserNotification"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.notification-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 268px;
  margin-top: 8px;
  padding: 12px 14px 12px 12px;
  color: var(--rasberry-red);
  border: 2px solid var(--rasberry-red);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgb(0 0 0 / 12%);
  cursor: pointer;

  &:first-child {
    margin-top: 0;
  }

  .notification-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .notification-title {
      color: var(--rasberry-red);
    }

    .close-button {
      width: 24px;
      height: 24px;
    }
  }

  .notification-info {
    margin-top: 6px;

    .notification-text {
      margin-top: 4px;
      font-weight: var(--font-weight-bold);
    }
  }

  .notification-actions-container {
    color: #ff2d53;
    margin-top: 5px;

    .notification-action,
    :deep(.notification-action) {
      display: flex;
      align-items: center;
      justify-content: start;
      text-align: left;
      gap: 8px;

      .arrow-icon {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
